import React from 'react';
import Spinner from '../../common/Spinner.jsx';
import styled from 'styled-components';

const Wrapper = styled.div`
	#daily_recap_modal {

		.legend-item {
			margin-top: 0;
			margin-bottom: 5px;
			padding: 5px;
			position: relative;
			border-left: 3px solid transparent;

			&:before {
				font-family: 'icone-gc';
				color: inherit;
				position: absolute;
			}

			&.legend-item-gray {
				color: #585858;
				background-color: #eeeeee;
				border-color: #585858;
			}

			&.legend-item-dark-blue {
				color: #00252b;
				background-color: #ccdadd;
				border-color: #004753;
			}

			&.legend-item-orange {
				color: #ff832b;
				background-color: rgba(255, 131, 43, 0.2);
				border-color: #ff832b;
			}

			&.legend-item-green {
				color: #2ca000;
				background-color: rgba(43, 160, 0, 0.2);
				border-color: #2ca000;
			}
		}

		.modal-header {
			.btn {
				padding: .2rem .5rem;

				&.no-effect {
					color: #fff;
					background-color: #637A86!important;
					:hover {
						cursor: unset;
						outline: none;
						box-shadow: none;
						background-color: #637A86!important;
						opacity: 1;
						border: none;
					}
				}
			}
			.close {
				color: #fff;
				font-size: 30px;
				opacity: 1;
			}
		}

		/* MODAL RECAP TABLE */
		table {
			table-layout: fixed;

			thead tr th {
				padding: 15px 0!important;
				line-height: .9rem;
				overflow-wrap: break-word;
			}
			thead {
				border: none;
			}
			thead th {
				border-top: none;
				border-bottom: none;
			}
			tbody {
				tr, th, td {
					border: none;
				}
				tr {
					td:first-child {
						border-left: none!important;
					}
				}
			}
			td, thead th {
				text-align: center;
			}
			td, th {
				padding: 0;
				vertical-align: middle;
			}
			tbody tr th {
				line-height: .9rem;
				overflow-wrap: break-word;
			}
			tbody tr {
				padding: 0;
				height: 50px;
				vertical-align: middle;
			}
			tbody td {
				border-left: 1px solid #F0F0F0;
			}
			.thick-border {
				border-top: 4px solid #F0F0F0;
			}
		}
		table.recap-table thead,
		table.recap-table thead tr {
			border: none;
		}
		table.recap-table tr {
			border-bottom: 1px solid #F0F0F0;
		}
		table.recap-table tr:last-child {
			border-bottom: none;
		}

		/* MODAL FILES TABLES */
		.files-table-title {
			background-color: #F0F0F0;
			text-align: center;
			font-size: .9rem;
			font-weight: 500;
			height: 40px;
			line-height: 40px;
			width: 100%;
			margin-bottom: 4px;
		}
		.files-table {
			tr {
				margin-bottom: 2px;

				td {
					vertical-align: top;
					width: 20%;
					font-size: .8rem;
					line-height: 1rem;

					span {
						display: block;
						font-size: .8rem;
					}
				}
			}
			tr, td {
				border-bottom: none;
			}
			.alert-gc {
				color: #000;
				padding: 10px;
				margin-top: 0;
				margin-bottom: 5px;
				transition: .3s;
			}
			.alert-gc:not(.alert-small) {
				text-transform: capitalize;
				color: #000;
				text-align: left;
				padding: 10px;
				margin-top: 0;
				margin-bottom: 5px;
			}
		}

		@media only screen and (max-width: 700px) {
			padding: 0 !important;
			.modal-dialog {
				width: 100%;
				max-width: none;
				height: 100%;
				margin: 0;
			}
			.modal-content {
				height: 100%;
				border: 0;
				border-radius: 0;

				.modal-header {
					border-radius: 0;
				}
				.modal-body {
					overflow-y: auto;
				}
			}
		}
	}
`;

export default function RequestsHotelsCalendarModal(props) {
	const {date, handlePrevDayFunction, handleNextDayFunction, isLoading, recapContent, filesContent} = props
	var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

	// Produtcs types recap
	let productsType = [];
	for (var key in recapContent) {
		if (recapContent.hasOwnProperty(key)) {
			productsType.push(recapContent[key]);
		}
	}

	// Files recap
	let files_pending = [];
	let files_open = [];
	let files_underoption = [];
	let files_booked = [];

	for(let f in filesContent){
		switch(filesContent[f][0]){
			case 'pending':
				files_pending.push(
					<a 
						key={f}
						href="#"
						data-part="+"
						data-target={'providers//requests_hotels/details/' + filesContent[f][1]['requests_hotels_id']} 
						className="js-nav get_part_link" 
						data-dismiss="modal"
					>
						<div className="legend-item legend-item-gray text-left">
							<span className="font-weight-bold text-uppercase">
								{((filesContent[f][1]['societe'] == null) ? '' : filesContent[f][1]['societe'])}
							</span>
							<span>
								{filesContent[f][1]['surname'].toLowerCase()} {filesContent[f][1]['name'].toLowerCase()}
							</span>
							<span>{filesContent[f][1]['pax']} PAX</span>
						</div>
					</a>
				);
				break;
			case 'open':
				files_open.push(
					<a 
						key={f}
						href="#"
						data-part="+"
						data-target={'providers//requests_hotels/details/' + filesContent[f][1]['requests_hotels_id']} 
						className="js-nav get_part_link" 
						data-dismiss="modal"
					>
						<div className="legend-item legend-item-dark-blue text-left">
							<span className="font-weight-bold text-uppercase">
								{((filesContent[f][1]['societe'] == null) ? '' : filesContent[f][1]['societe'])}
							</span>
							<span>
								{filesContent[f][1]['surname'].toLowerCase()} {filesContent[f][1]['name'].toLowerCase()}
							</span>
							<span>{filesContent[f][1]['pax']} PAX</span>
						</div>
					</a>
				);
				break;
			case 'underoption':
				files_underoption.push(
					<a 
						key={f}
						href="#"
						data-part="+"
						data-target={'providers//requests_hotels/details/' + filesContent[f][1]['requests_hotels_id']} 
						className="js-nav get_part_link" 
						data-dismiss="modal"
					>
						<div className="legend-item legend-item-orange text-left">
							<span className="font-weight-bold text-uppercase">
								{((filesContent[f][1]['societe'] == null) ? '' : filesContent[f][1]['societe'])}
							</span>
							<span>
								{filesContent[f][1]['surname'].toLowerCase()} {filesContent[f][1]['name'].toLowerCase()}
							</span>
							<span>{filesContent[f][1]['pax']} PAX</span>
						</div>
					</a>
				);
				break;
			case 'booked':
				files_booked.push(
					<a 
						key={f}
						href="#"
						data-part="+"
						data-target={'providers//requests_hotels/details/' + filesContent[f][1]['requests_hotels_id']} 
						className="js-nav get_part_link" 
						data-dismiss="modal"
					>
						<div className="legend-item legend-item-green text-left">
							<span className="font-weight-bold text-uppercase">
								{((filesContent[f][1]['societe'] == null) ? '' : filesContent[f][1]['societe'])}
							</span>
							<span>
								{filesContent[f][1]['surname'].toLowerCase()} {filesContent[f][1]['name'].toLowerCase()}
							</span>
							<span>{filesContent[f][1]['pax']} PAX</span>
						</div>
					</a>
				);
				break;
			default:
		}
	}

	return (
		<Wrapper>
			<div className="modal fade" id="daily_recap_modal" tabIndex="-1" role="dialog" aria-hidden="true">
				<div className="modal-dialog modal-dialog-centered modal-lg" role="document">
					<div className="modal-content border-0">
						<div className="modal-header border-0 bg-gc-dark-blue text-white w-100 d-flex justify-content-between align-items-center py-0">
							<div className="btn-group">
								<button
									className="btn btn-secondary" 
									type="button"
									onClick={handlePrevDayFunction}
								>
									<span className="fa fa-chevron-left"></span>
								</button>
								<button 
									className="btn btn-secondary" 
									type="button"
									onClick={handleNextDayFunction}
								>
									<span className="fa fa-chevron-right"></span>
								</button>
							</div>

							<h5 className="d-block modal-title">
								{
								// 'recap_of'.trad() + ' ' + 
								new Date(date).toLocaleDateString(ENV.lang.replace('_', '-'), options)
								}
							</h5>

							<button type="button" className="close text-white m-0" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div className="modal-body">
							{
								isLoading ?
								<div className="text-center my-5">
									<Spinner/>	
								</div>
								:
								<div>
									{
										recapContent.length > 0 || filesContent.length > 0 ?
										<div>
											<table className="table recap-table m-0">
												<thead>
													<tr>
														<th scope="col"></th>
														<th className="legend-item legend-item-gray" scope="col">{TRAD.pending.trad()}</th>
														<th className="legend-item legend-item-dark-blue" scope="col">{TRAD.en_cours.trad()}</th>
														<th className="legend-item legend-item-orange" scope="col">{TRAD.underoption.trad()}</th>
														<th className="legend-item legend-item-green" scope="col">{TRAD.booked.trad()}</th>
													</tr>
												</thead>
												<tbody>
													{
														productsType.map((e, i) => 
															<tr key={i}>
																<td>
																	{e.trad}
																</td>
																<td>
																	{e.pending}
																</td>
																<td>
																	{e.open}
																</td>
																<td>
																	{e.underoption}
																</td>
																<td>
																	{e.booked}
																</td>
															</tr>
														)  
													}
												</tbody>
											</table>
											<h3 className="files-table-title">{TRAD.dispositionFiles.trad()}</h3>
											<table className="table files-table m-0">
												<tbody>
													<tr>
														<td>

														</td>
														<td>
															{files_pending}
														</td>
														<td>
															{files_open}
														</td>
														<td>
															{files_underoption}
														</td>
														<td>
															{files_booked}
														</td>
													</tr>
												</tbody>
											</table>
										</div>
										:
										<p className="text-center m-0 my-5">{'no_events'.trad()}</p>
									}									
								</div>
							}
						</div>
					</div>
				</div>
			</div>			
		</Wrapper>
	)
}